import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IRegister = GRpcRequestType<MainApi.AuthGrpcContractClient['Register']>;

@Injectable()
export class AuthGrpcContractService extends GrpcCommonService<MainApi.AuthGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.AuthGrpcContractClient) {
    super();
  }

  register(request: IRegister) {
    return from(
      this._GrpcContract.Register(
        new MainApi.BaseLoginWpc(MainApi.BaseLoginWpc.fromObject(request) as any),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
